import React, { useEffect, useState } from 'react'
import { Form, Col, Row, Button, Container } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import swal from 'sweetalert'
import img_contact from '../../images/contact-us.png'
import img_contact_m from '../../images/contact-us-m.png'
import ReCAPTCHA from 'react-google-recaptcha'

const RECAPTCHA_SITE_KEY = process.env.GATSBY_RECAPTCHA_SITE_KEY

const ContactFormPage = (props) => {
    const [regions, setRegions] = useState({})
    const [captchaToken, setCaptchaToken] = useState(null)

    const { t } = useTranslation()
    const items = props.data

    useEffect(() => {
        axios
            .get(`${process.env.GATSBY_API_URL}/api/v1/regions`)
            .then((res) => {
                const data = res.data
                setRegions(data)
            })
            .catch((err) => console.log(err))
    }, [])

    const {
        register,
        handleSubmit,
        setError,
        errors,
        reset,
        formState: { isSubmitting },
    } = useForm()
    const onSubmit = async (data) => {
        if (data.honeypot) {
            return
        }

        if (!captchaToken) {
            setError(
                'submit',
                'manual',
                'Please verify that you are not a robot.'
            )
            return
        }

        const { honeypot, ...payload } = data

        try {
            await axios.post(`${process.env.GATSBY_API_URL}/api/v1/contact`, {
                ...payload,
            })
            // setSubmitted(true);
            reset()
            setCaptchaToken(null)
            swal({
                title: 'Thank You !',
                text: 'Email sent successfully.',
                icon: 'success',
            }).then(function () {
                const lang = localStorage.getItem('lang') || 'en'
                window.location.href = '/' + lang + '/contact-us?email=sent'
            })
        } catch {
            setError('submit', 'submitError')
        }
    }

    const showSubmitError = (msg) => <p className="msg-error">{msg}</p>
    const showForm = (
        <Form onSubmit={handleSubmit(onSubmit)} id="contactForm" method="post">
            <Form.Group
                as={Col}
                className="px-0"
                style={{ display: 'none' }}
                aria-hidden="true"
            >
                <label htmlFor="honeypot">Do not fill this field</label>
                <input
                    name="honeypot"
                    id="honeypot"
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    ref={register}
                />
            </Form.Group>

            <Form.Group as={Col} className="px-0">
                <select
                    name="country"
                    className="custom-select text-center form-control"
                    id="inputCountry"
                    ref={register({ required: true })}
                    disabled={isSubmitting}
                >
                    <option>{t('contact.option')}</option>
                    {Object.keys(regions).map((key) => {
                        return (
                            <option key={key} value={regions[key]}>
                                {regions[key]}
                            </option>
                        )
                    })}
                </select>
                {errors.country && (
                    <p className="required">This field is required</p>
                )}
            </Form.Group>
            <Form.Group as={Col} className="px-0">
                <input
                    name="name"
                    type="text"
                    label={t('contact.name')}
                    className="input-name form-control"
                    id="inputName"
                    placeholder="Full Name"
                    ref={register({ required: true })}
                    disabled={isSubmitting}
                />
                {errors.name && (
                    <p className="required">This field is required</p>
                )}
            </Form.Group>
            <Form.Group as={Col} className="px-0">
                <input
                    name="email"
                    type="email"
                    label={t('contact.email')}
                    className="input-email form-control"
                    id="inputEmail"
                    placeholder="Email"
                    ref={register({ required: true })}
                    disabled={isSubmitting}
                />
                {errors.email && (
                    <p className="required">This field is required</p>
                )}
            </Form.Group>
            <Form.Group as={Col} className="px-0">
                <textarea
                    name="message"
                    rows="8"
                    label={t('contact.message')}
                    placeholder={t('contact.message')}
                    ref={register({ required: true })}
                />
                {errors.message && (
                    <p className="required">This field is required</p>
                )}
            </Form.Group>

            <Form.Group as={Col} className="px-0 mb-3">
                {typeof window !== 'undefined' && RECAPTCHA_SITE_KEY && (
                    <ReCAPTCHA
                        sitekey={RECAPTCHA_SITE_KEY}
                        onChange={(token) => {
                            setCaptchaToken(token)
                        }}
                    />
                )}
            </Form.Group>

            <Button
                variant="primary"
                type="submit"
                className="btn-primary__fill-pink cta-submit"
                disabled={isSubmitting}
            >
                {t('contact.submit')}
            </Button>
        </Form>
    )

    return (
        <Container fluid className="px-0">
            <Row noGutters className="margin-row">
                <Col sm={12} md={7}>
                    <div className="contact-image">
                        <img
                            src={img_contact}
                            alt="image-contact"
                            className="img-fluid d-none d-md-block"
                        />
                        <img
                            src={img_contact_m}
                            alt="image-contact"
                            className="img-fluid d-block d-md-none"
                        />
                    </div>
                </Col>
                <Col sm={12} md={5}>
                    <div className="page-title">
                        <h1>{t('contact.title')}</h1>
                    </div>
                    <div className="contact-form">
                        {errors &&
                            errors.submit &&
                            showSubmitError(errors.submit.message)}
                        {showForm}
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ContactFormPage
